import 'twin.macro'

import MoonIcon from 'assets/icons/moon.svg?component'
import SunIcon from 'assets/icons/sun.svg?component'
import Toggle from 'components/UI/Toggle'
import { useTheme } from 'contexts/theme-context'
import { useCallback } from 'react'
import tw, { TwStyle } from 'twin.macro'

const ThemeToggle = ({ twStyle }: { twStyle?: TwStyle }) => {
  const { isDarkTheme, setTheme } = useTheme()

  const toggleHandler = useCallback(() => {
    setTheme(isDarkTheme ? 'light' : 'dark')
  }, [isDarkTheme, setTheme])

  return (
    <Toggle
      toggleHandler={toggleHandler}
      isOn={isDarkTheme}
      twStyle={twStyle}
      icons={[
        <MoonIcon css={isDarkTheme ? tw`text-[#ffffff]` : tw`text-[#8e8e93]`} key='moon' />,
        <SunIcon css={isDarkTheme ? tw`text-[#b7bbbd]` : tw`text-[#ffffff]`} key='sun' />
      ]}
    />
  )
}

export default ThemeToggle
